<template>
  <section>
    <transition>
     <div>

      <div class="content">

        <div class="login">

          <div class="div-atuacao">
            <p class="titulo_card">DADOS PESSOAIS</p>
            <div v-if="usuario != null" class="container-usuario">

              <div v-if="usuario.Foto">
                <img class="foto" :src="usuario.Foto"/>
              </div>

              <div v-if="usuario.NomeCompleto" class="nome">
                <b>{{usuario.NomeCompleto}}</b>
              </div>
              <div v-if="usuario.Cpf" class="celular">
                Cpf: {{usuario.Cpf}}
              </div>
              <div v-if="usuario.Telefone" class="celular">
                Celular: {{usuario.Telefone}}
              </div>
              <div v-if="usuario.Email" class="email">
                {{usuario.Email}}
              </div>
              <div v-if="usuario.EnderecoCidade" class="cidade">
                {{usuario.EnderecoCidade}} - {{usuario.EnderecoUF}}
              </div>

              <div class="atualizar" @click="atualizarCadastro()">
                <i class="fas fa-user-edit"></i> Atualizar dados
              </div>

              <div class="logout" @click="logout()">
                <i class="fas fa-sign-out-alt"></i> Sair do sistema
              </div>
            </div>
         </div>

        </div>

        <div class="cadastro">

          <div class="div-atuacao">

            <p class="titulo_card">COMPRAS REALIZADAS</p>

            <div v-if="compras.length > 0" class="compras-titulo">
              <span></span>
              <span>Produto / Preço Promocional</span>
              <span>Qtd</span>
              <span>Data/Unidade</span>
              <span></span>
            </div>

            <div v-else class="sem-compras">
              <p><br>Você ainda não possui compras no novo sistema do Ilha do Caranguejo!</p>
              <button class="btn" @click="rotaHome()">COMECE AGORA MESMO!</button>
            </div>

            <div v-for="compra in compras" :key="compra.id" class="compras">
                <div class="produto-imagem">
                  <img :src="compra.ProdutoUrlImagens" />
                </div>
                <div class="produto-titulo">
                    <span class="bold">{{ compra.ProdutoTitulo }}</span>
                    <span class="codigo-id">{{ compra.PrecoPromocional | numeroPreco }} / {{ compra.CodigoPedido.substring(compra.CodigoPedido.length - 6) }}</span>
                </div>
                <div class="produto-quantidade">
                    1 und
                </div>
                <div class="produto-data-horario azul">
                    <span>{{compra.SemData === true ? 'Exceto Domingos e Feriados' : new Date(compra.DataPromocao.toDate().toISOString()) | moment("ddd, DD/MM")}}</span>
                    <span>{{compra.Horario}}</span>
                    <span class="bold">{{compra.SemData === true ? 'Qualquer unidade' : compra.Unidade }}</span>
                </div>
                <div v-if="compra.StatusPromocao == 'Consumida' || compra.StatusPromocao == 'Cancelada'" :class="compra.StatusPromocao == 'Cancelada' ? 'status-cancelada' : 'status'">
                    {{ compra.StatusPromocao }}
                </div>
                <div v-else class="qr-code">
                  <qrcode-vue :value="compra.valorQrCode" :size="100"></qrcode-vue>
                </div>
            </div>
          </div>

        </div>

      </div>

     </div>

    </transition>
  </section>
</template>

<script>
import { dbCadastro, auth } from '@/firebase_cadastro.js'
import { db } from '@/firebase.js'
import { mapActions } from 'vuex'
import QrcodeVue from 'qrcode.vue'
import _ from 'lodash'

export default {
  name: 'MinhaConta',
  components: {
    QrcodeVue
  },
  data: function () {
    return {
      usuario: '',
      compras: []
    }
  },
  created () {
    this.limparLoginCpf()
    this.limparFinalizacaoPedido()
    this.getUsuario(this.$store.state.usuario.usuario)
    if (this.$store.state.usuario.usuario == null) {
      this.$router.push({name: 'Login'})
    }
    document.title = 'Minha Conta - Ilha do Caranguejo'
  },
  methods: {
    ...mapActions('usuario', ['usuarioLogout', 'loginCpf']),
    ...mapActions('configuracoes', ['cadastroView']),
    ...mapActions('menu', ['finalizacaoPedido', 'toggleMenu']),
    limparLoginCpf () {
      this.loginCpf(false)
    },
    limparFinalizacaoPedido () {
      this.finalizacaoPedido(false)
      this.toggleMenu(false)
    },
    async logout () {
      await auth.signOut()
      await localStorage.removeItem('usuarioAtual')
      await this.usuarioLogout()
      this.cadastroView(false)
      this.$router.push({name: 'HomePage'})
    },
    rotaHome () {
      this.$router.push({name: 'HomePage'})
    },
    atualizarCadastro () {
      this.$router.push({name: 'AtualizarCadastro'})
    },
    getUsuario () {
      this.usuario = JSON.parse(localStorage.getItem('usuarioAtual'))
      this.getCompras()
    },
    getCompras () {
      this.documentoProps = JSON.parse(sessionStorage.getItem('documentoProps'))
      db.collection('Clientes').doc(this.$store.state.usuario.usuario.Email).collection('Compras').orderBy('DataHoraPedido', 'desc').onSnapshot((querySnapshot) => {
        querySnapshot.docChanges().forEach((change) => {
          if (change.type === 'added') {
            var compra = change.doc.data()
            compra.id = change.doc.id
            compra.valorQrCode = change.doc.id + this.$store.state.usuario.usuario.id
            this.compras.push(compra)
            this.compras = _.sortBy(this.compras, o => [o.DataPromocao, o.Horario, o.Titulo, o.CodigoPedido]).reverse()
          } else if (change.type === 'modified') {
            this.compras = this.compras.filter((obj) => {
              return obj.id !== change.doc.id
            })
            var compra2 = change.doc.data()
            compra2.id = change.doc.id
            compra2.valorQrCode = change.doc.id + this.$store.state.usuario.usuario.id
            this.compras.push(compra2)
            this.compras = _.sortBy(this.compras, o => [o.DataPromocao, o.Horario, o.Titulo, o.CodigoPedido]).reverse()
          } else if (change.type === 'removed') {
            this.compras = this.compras.filter((obj) => {
              return obj.id !== change.doc.id
            })
          }
        })
      })
    }
  }
}
</script>

<style scoped>
.content {
  max-width: 1174px;
  margin: 0 auto;
  padding: 30px 10px;
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 40px;
  grid-template-areas:
    "login cadastro"
}

@media (max-width: 960px) {
  .content {
    padding: 20px 10px;
    margin: 0;
    grid-template-columns: 1fr;
    grid-template-columns: 100%;
    grid-template-areas:
      "login"
      "cadastro"
  }
}
/* login */
.login {
  grid-area: login;
  background: #fff;
  box-shadow: 5px 5px 15px 0px rgba(44, 44, 44, 0.15);
  padding: 10px 20px 25px 20px;
}

.titulo_card {
  font-size: 1.2rem;
  color: #2E9189;
  font-weight: 600;
  border-bottom: 1px solid #2E9189;
  padding: 5px 0;
  margin: 0 0 15px 0;
}

.foto {
  max-width: 120px;
  margin: 10px auto;
}

.label {
  text-align: left;
}

.container-usuario div {
  margin: 10px 0;
}

.atualizar {
  padding: 40px 0 15px 0;
}

.atualizar, .logout {
  color: #F85E28;
  font-weight: 500;
  font-size: 0.95em;
  cursor: pointer;
}

.atualizar:hover, .logout:hover {
  color: #B4AE8A;
}

button {
  color: #fff;
  padding: 10px 20px;
  border-radius: 4px;
  border: 0;
  font-size: 1.05em;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(30, 60, 90, 0.2);
  transition: all 0.3s;
}

button:hover {
  transform: scale(1.1);
}

/* CADASTRO */
.cadastro {
  grid-area: cadastro;
  background: #fff;
  box-shadow: 5px 5px 15px 0px rgba(44, 44, 44, 0.15);
  padding: 10px 20px 25px 20px;
}

.cadastro-form {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
}

@media (max-width: 960px) {
  .cadastro-form {
    grid-template-columns: 1fr;
    gap: 40px;
}
}

.cadastro-form p {
  padding: 0 0 0 5%;
  margin: 20px 0 5px 0;
}

.bt-cadastro {
  background: #2E9189;
  margin: 20px 0;
}

.bt-cadastro:hover {
  background: #186B65;
}

.compras-titulo {
  grid-template-columns: 120px 2fr 1fr 2fr 1fr;
  display: grid;
  font-size: 0.8rem;
  font-weight: 600;
  background: #f3f3f3;
  padding: 10px 0;
}

.compras-titulo span {
  margin: 0 auto;
}

.compras {
  display: grid;
  grid-template-columns: 120px 2fr 1fr 2fr 120px;
  gap: 20px;
  padding: 20px 0 20px 0;
  align-content: center;
  align-items: center;
  border-bottom: 1px solid #f3f3f3;
}

.compras img {
  width: 120px;
}

.status {
  font-size: 0.9em;
  font-weight: 600;
  color: #21c25e;
}

.status-cancelada {
  font-size: 0.9em;
  font-weight: 600;
  color: #FF0000;
}

.div-atuacao {
  margin: 0 0 20px 0;
}

.outer-div {
  height: 81px;
  width: 120px;
  overflow: hidden;
  grid-row: span 2;
  margin: 5px 0 0 0;
}

.inner-div {
  height: 100%;
  width: 100%;
  background-size: cover;
  background-position: center;
  transition: all 0.7s ease;
  grid-row: span 2;
}

.inner-div:hover {
  transform: scale(1.1);
}

.dataok, .palestrante {
  color: #e08f8f;
  margin: 5px 0;
  display: block;
}

.sem-compras {
  margin: 0 auto;
}

.sem-compras button {
  text-align: center;
  margin: 20px auto;
}

.produto-titulo {
  display: grid;
  gap: 5px;
}

.produto-imagem img{
  width: 120px;
  margin: 0 auto;
}

.produto-data-horario {
  display: grid;
  gap: 5px;
}

.azul {
  color: #00f;
}

.codigo-id {
  font-size: 0.8em;
}

@media (max-width: 960px) {
  .atualizar {
    padding: 10px 0 10px 0;
  }
  .cadastro {
    padding: 10px 20px 10px 20px;
    width: 100%;
    justify-self: center;
  }
  .compras {
    grid-template-columns: 1fr;
    margin-top: 20px;
    border-bottom: 1px solid #666;
  }
  .compras-titulo {
    display: none;
  }
  .produto-quantidade {
    display: none;
  }
  .produto-imagem img{
    width: 98%;
    max-width: 400px;
  }
  .produto-data-horario {
    display: flex;
    justify-content: center;
  }
  .produto-data-horario span {
    padding: 0 0 0 20px;
  }
  .qr-code {
    max-width: 80%;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/MinhaConta.vue